import ModelUtil from '@leverege/model-util';
const TYPE = 'molten.FilterSourcesModel';

/**
 * This Represents the various pieces of a combined filter. Each Source, represented
 * by a name and a FilterSourceModel, are stored in this model. They are combined to 
 * produce a sort and a filter, that can be used as a request to the imagine server.
 */
function create() {
  return {
    type: TYPE,
    sources: {},
    filter: null,
    sort: null,
    baseFilter: null,
    baseSort: null
  };
}
function calculate(mdl) {
  if (mdl == null) {
    return mdl;
  }
  if (mdl.sources == null && mdl.baseFilter == null && mdl.baseSort == null) {
    return {
      ...mdl,
      filter: null,
      sort: null
    };
  }
  const srcs = mdl.sources ? Object.values(mdl.sources).filter(s => s.active !== false) : [];
  srcs.sort((a, b) => {
    return a.priority - b.priority;
  });
  const nf = srcs.map(source => source.filter).filter(s => s != null);
  const ns = srcs.reduce((accum, src) => {
    return src.sort == null ? accum : [...accum, ...src.sort];
  }, []);
  if (mdl.baseFilter) {
    nf.push(mdl.baseFilter);
  }
  if (mdl.baseSort) {
    ns.push(mdl.baseSort);
  }
  const filter = nf.length <= 1 ? nf[0] || null : {
    type: 'logical',
    operator: 'and',
    conditions: nf
  };
  const sort = ns.length === 0 ? null : ns;
  return {
    ...mdl,
    filter,
    sort
  };
}

// Change the set methods to recompute the filter and source
const sourceMethods = ModelUtil.createAllMap('sources', 'Source', 'Sources');
const original = {
  ...sourceMethods
};
sourceMethods.setSource = (mdl, name, value) => {
  const r = original.setSource(mdl, name, value);
  return r !== mdl ? calculate(r) : r;
};
sourceMethods.setSources = (mdl, map) => {
  const r = original.setSources(mdl, map);
  return r !== mdl ? calculate(r) : r;
};
sourceMethods.removeSource = (mdl, name) => {
  const r = original.removeSource(mdl, name);
  return r !== mdl ? calculate(r) : r;
};
sourceMethods.clearSources = mdl => {
  const r = original.clearSources(mdl);
  return r !== mdl ? calculate(r) : r;
};
const nrm = sourceMethods.sources();
nrm.set = sourceMethods.setSource;
nrm.remove = sourceMethods.removeSource;
nrm.setAll = sourceMethods.setSources;
nrm.clear = sourceMethods.clear;
const baseFilterMethods = ModelUtil.createAllValue('baseFilter');
const originalBaseFilterMethods = {
  ...baseFilterMethods
};
baseFilterMethods.setBaseFilter = (mdl, value) => {
  const r = originalBaseFilterMethods.setBaseFilter(mdl, value);
  return r !== mdl ? calculate(r) : r;
};
const baseSortMethods = ModelUtil.createAllValue('baseSort');
const originalBaseSortMethods = {
  ...baseSortMethods
};
baseSortMethods.setBaseSort = (mdl, value) => {
  const r = originalBaseSortMethods.setBaseSort(mdl, value);
  return r !== mdl ? calculate(r) : r;
};
function getMetadata(f) {
  if (f.sources) {
    return Object.entries(f.sources).reduce((accum, [key, fs]) => {
      // eslint-disable-next-line no-param-reassign
      accum[key] = fs.metadata;
      return accum;
    }, {});
  }
  return null;
}
export default {
  TYPE,
  create,
  ...sourceMethods,
  getFilter: ModelUtil.createGetValue('filter'),
  getSort: ModelUtil.createGetValue('sort'),
  ...baseFilterMethods,
  ...baseSortMethods,
  getMetadata,
  calculate
};